import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Notification from "../notification/Notification";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";

import { StyledClipboardInput, StyledCopyButton } from "./styledClipboardInput";

const ClipboardInput = ({ id, name, label, value, readonly, className }) => {
  const { t } = useTranslation("otherInterface");
  const [copy, setCopy] = useState(false );

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledClipboardInput>
        <TextField
          className={`clipboard-input ${className}`}
          id={id}
          label={label}
          name={name}
          value={value}
          variant="filled"
          InputProps={{
            readOnly: readonly
          }}
        />
        <CopyToClipboard
          text={value}
          onCopy={() => {
            setCopy(true);
            setNotification({ ...notification, visible: true, type: "success", message: t("clipboardInput.copied") });
          }}
        >
          <StyledCopyButton>
            <span className="icon-light-copy" />
          </StyledCopyButton>
        </CopyToClipboard>
      </StyledClipboardInput>
    </>
  );
};

export default ClipboardInput;